export default __webpack_public_path__ + "static/media/holiday.b34c9dd9.jpg";